<ms-header-content
    [event]="event"
    [live]="event.scoreboard.started"
    [feature]="feature"
    [isNewEDPScoreboard]="isNewEDPScoreboard"
    (toggle)="densityToggled($event)"
    (videoPinToggle)="onVideoPinToggle($event)" />

@if (setTabs) {
    @if (isSitemapEnabled) {
        <ng-container *msComponentProxy="sitemapComponent" />
    } @else {
        @if (!event.isFinished() && setTabs.length > 1) {
            <ms-event-header-tabs [tabs]="setTabs" [event]="event" (activeTab)="setTabSelected($event)" />
        }
        @if (!isSitemapEnabled && setTabs.length && isHeaderSubNavigationEnabled) {
            <ms-header-sub-navigation [tabs]="setTabs" (tabChange)="tabClicked($event)" />
        }
    }
}
